import RemediationBox from '../RemediationBox';
import { REMEDIATION_CONSTANTS } from '../NRRemediation.constants';
import React from 'react';
import Box from '@mui/material/Box';

function NRLicenseIssueRemediationStepOne() {
  return (
    <Box my={5}>
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.UNREVIEWED}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.UNREVIEWED}
        subtitle={REMEDIATION_CONSTANTS.STATUS.DESCRIPTIONS.UNREVIEWED}
        showAlert={false}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.IN_REVIEW}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.IN_REVIEW}
        subtitle={REMEDIATION_CONSTANTS.STATUS.DESCRIPTIONS.IN_REVIEW}
        showAlert={false}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.RESOLVED}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.RESOLVED}
        subtitle={REMEDIATION_CONSTANTS.STATUS.DESCRIPTIONS.RESOLVED}
        showAlert={false}
      />
    </Box>
  );
}

export default NRLicenseIssueRemediationStepOne;
